type ToastSeverity = 'success' | 'info' | 'warn' | 'error'

export interface AppToastEvent {
  severity: ToastSeverity
  summary: string
  detail?: string
  life: number
}

export function showToast(severity: ToastSeverity, summary: string, detail?: string) {
  window.dispatchEvent(
    new CustomEvent<AppToastEvent>('app-toast', {
      detail: { severity, summary, detail, life: 5000 },
    }),
  )
}
